import React, { useState } from 'react';
import SEO from '../components/SEO';

const testimonials = [
  {
    name: 'Sophia L.',
    photo: 'https://randomuser.me/api/portraits/women/44.jpg',
    text: 'The most relaxing experience I have ever had. The staff are wonderful and the environment is so peaceful.',
  },
  {
    name: 'James K.',
    photo: 'https://randomuser.me/api/portraits/men/45.jpg',
    text: 'From the moment I walked in, I felt at ease. The massage was incredible and the space is beautiful.',
  },
  {
    name: 'Emily R.',
    photo: 'https://randomuser.me/api/portraits/women/46.jpg',
    text: 'I love the attention to detail and the calming atmosphere. Highly recommend for anyone needing a reset.',
  },
  {
    name: 'Michael B.',
    photo: 'https://randomuser.me/api/portraits/men/47.jpg',
    text: 'A truly luxurious spa experience. I left feeling refreshed and renewed.',
  },
  {
    name: 'Ava T.',
    photo: 'https://randomuser.me/api/portraits/women/47.jpg',
    text: 'The best spa in the city! The team is so professional and caring.',
  },
];

function Testimonials() {
  const [page, setPage] = useState(0);
  const perPage = 2;
  const totalPages = Math.ceil(testimonials.length / perPage);
  const current = testimonials.slice(page * perPage, page * perPage + perPage);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8F6F2] via-[#E8F5F2] to-[#F9E9E9] font-sans pb-16">
      <SEO
        title="Client Reviews & Testimonials | Healing Lotus Spa Dallas"
        description="Read honest reviews from clients of Healing Lotus Skin Spa in Dallas. Real experiences with our massages, facials, and wellness treatments."
        path="/testimonials"
      />
      <section className="container mx-auto py-16 px-4 md:px-0">
        <h1 className="text-4xl md:text-5xl font-bold text-center text-[#222] mb-8 font-serif">Client Testimonials</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-8">
          {current.map((t, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-md p-8 flex flex-col items-center text-center hover:shadow-xl transition">
              <img src={t.photo} alt={t.name} className="w-16 h-16 rounded-full object-cover mb-4 border-4 border-[#B2D8C5]" />
              <div className="text-[#B2D8C5] text-4xl mb-2">"</div>
              <p className="text-[#6B7280] mb-4 italic">{t.text}</p>
              <div className="font-semibold text-[#222]">{t.name}</div>
            </div>
          ))}
        </div>
        {/* Pagination */}
        <div className="flex justify-center space-x-2">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              className={`w-3 h-3 rounded-full ${i === page ? 'bg-[#B2D8C5]' : 'bg-[#F7CAC9]'} transition`}
              onClick={() => setPage(i)}
              aria-label={`Go to page ${i + 1}`}
            />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Testimonials; 